<template>
  <main id="main">
    <div class="bread_crumb">
      <div class="bread_crumb_inner">
        <a href="" class="home">홈</a>
        <a href="">후원캠페인</a>
      </div>
    </div>
    <CampaignListForm/>
  </main>
</template>
<script>
import CampaignListForm from '@/components/campaign/CampaignListForm.vue';
export default {
  components: {
    CampaignListForm
  }
}
</script>
<style lang="">

</style>